<template>
  <b-modal
      id="bv-modal-yesno"
      ref="modal"
      data-test-path="dialog-yes-no"
      @hide="onHide"
      @ok="onOk"
  >
    <template v-slot:modal-title>
      {{ title }}
    </template>
    <div class="d-block text-center" v-html="message"></div>

    <template #modal-footer="{close}">
      <b-container class="pl-0">
        <b-row>
          <b-col class="text-right">
            <b-button
                variant="plm-secondary"
                @click="onHide"
            > {{ noTitle }}
            </b-button>
            <b-button
                :variant="isYesDanger ? 'plm-danger-primary' : 'plm-primary'"
                data-test-path="yes-button-dialog"
                @click="onOk"
            >
              <font-awesome-icon v-if="isYesDanger" class="pl-1" icon="skull-crossbones"/>
              {{ yesTitle }}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>

  </b-modal>

</template>

<script>
export default {
  name: "YesNoDialog",
  async beforeMount() {
  },
  mounted() {
    let x = 5;
  },
  methods: {
    async onOk(ev) {
      if (this.resolve != null) {
        this.resolve(true);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },
    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve(false);
        this.resolve = null;
      }
      this.$refs.modal.hide();

    },
    reset() {
      this.resolve = null;
    }
  },
  data: () => ({
    isYesDanger: false,
    title: "title",
    message: "message",
    resolve: null,
    maxLength: 100,
    yesTitle: "Yes",
    noTitle: "No"
  })
}
</script>
